// extracted by mini-css-extract-plugin
export default {"mainWrapper":"_3tGjZ","loaderMain":"_6dGDP"};